





























































































































































































import {Component, Watch, Vue, Mixins} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {$, success, MixinUpload} from 'simpli-web-sdk'
import ChangePasswordComponent from '@/components/ChangePasswordComponent.vue'
import Responsavel from '@/model/resource/Responsavel'
import * as Helper from '@/helpers'
import ResponsavelPermissao from '@/model/resource/ResponsavelPermissao'
import {UploadConfig} from '@/config/upload.config'
// @ts-ignore
import {FileObject} from 'image-compressor.js'
import AutoCompleteDestinatario from '@/model/resource/AutoCompleteDestinatario'
import {convertFile, getAdminNome} from '@/helpers'
import {UFInitial} from '@/enums/UFInitial'

const metaInfo = () => ({
  title: $.t('view.manage.settings.title'),
})

@Component({
  metaInfo,
  components: {ChangePasswordComponent},
})
export default class ManageSettingsView extends Mixins(MixinUpload) {
  @Getter('auth/responsavel') user!: Responsavel
  @Action('auth/changePassword') changePassword!: Function
  @Getter('auth/responsavel') responsavelCache!: Responsavel
  @Action('auth/auth') auth!: Function
  @Action('refreshView') refreshView!: Function

  responsavel: Responsavel | null = null
  responsavelPermissao = new ResponsavelPermissao()
  newPasswordConfirmed: boolean = false
  userInteracting: boolean = false

  customQuestion: boolean = false

  Helper = Helper
  totalDestinatario = 0

  readonly UPLOAD_CONFIG = UploadConfig.buildDataPreset(1)

  get isUser() {
    return Helper.getUsuarioNome() !== ''
  }

  get isAdmin() {
    return Helper.getAdminNome() !== ''
  }

  get naoPermitirDataEntregaInferiorDataCriacao() {
    return this.responsavel ? !this.responsavel.permitirDataEntregaInferiorDataCriacao : false
  }
  set naoPermitirDataEntregaInferiorDataCriacao(val: boolean) {
    if (this.responsavel) {
      this.responsavel.permitirDataEntregaInferiorDataCriacao = !val
      this.persistDisableDataEntregaInferiorDataCriacao()
    }
  }

  get naoPermitirDataEntregaInferiorDataEmissao() {
    return this.responsavel ? !this.responsavel.permitirDataEntregaInferiorDataEmissao : false
  }
  set naoPermitirDataEntregaInferiorDataEmissao(val: boolean) {
    if (this.responsavel) {
      this.responsavel.permitirDataEntregaInferiorDataEmissao = !val
      this.persistDisableDataEntregaInferiorDataEmissao()
    }
  }

  get naoPermitirMultiplasFinalizacaoApp() {
      return this.responsavel ? !this.responsavel.permitirFinalizacaoMultiplaApp : false
  }
  set naoPermitirMultiplasFinalizacaoApp(val: boolean) {
      if (this.responsavel) {
          this.responsavel.permitirFinalizacaoMultiplaApp = !val
          this.persistDisableMultiplasFinalizacaoApp()
      }
  }

  async created() {
    this.responsavel = this.responsavelCache.clone()
    await this.responsavelPermissao.getResponsavelPermissao(this.user.$id)
    await this.$nextTick()
    this.userInteracting = true
    if (Helper.isSpinel()) {
      const total = await AutoCompleteDestinatario.getTotalCadastrado(this.user.idResponsavelPk)
      this.totalDestinatario = total.data
    }
  }

  @Watch('customQuestion')
  async customQuestionEvent(val: boolean) {
    if (!val && this.responsavel) {
      this.responsavel.perguntaPesquisaSatisfacao = ''
      this.responsavel.perguntaPesquisaSatisfacao2 = ''
    }
  }

  @Watch('responsavel.perguntaPesquisaSatisfacao', {immediate: true})
  @Watch('responsavel.perguntaPesquisaSatisfacao2', {immediate: true})
  async perguntaPesquisaSatisfacaoEvent() {
    const {responsavel} = this
    if (responsavel) {
      if (responsavel.perguntaPesquisaSatisfacao || responsavel.perguntaPesquisaSatisfacao2) {
        this.customQuestion = true
      } else if (this.responsavel) {
        this.responsavel.perguntaPesquisaSatisfacao = null
        this.responsavel.perguntaPesquisaSatisfacao2 = null
        this.customQuestion = false
      }
    }
  }

  @Watch('responsavel.receberNotificacoesCarga')
  async persistReceberNotificacoesCarga() {
    if (!this.userInteracting || !this.responsavel) {
      return
    }
    await this.responsavel.persistReceberNotificacoesCarga(this.responsavel)
    await this.auth()
    success('system.success.persist')
  }

  @Watch('responsavel.receberNotificacoesTrajeto')
  async persistReceberNotificacoesTrajeto() {
    if (!this.userInteracting || !this.responsavel) {
      return
    }
    await this.responsavel.persistReceberNotificacoesTrajeto(this.responsavel)
    await this.auth()
    success('system.success.persist')
  }

  @Watch('responsavel.permitirDataPrevisao')
  async persistPermitirDataPrevisao() {
    if (!this.userInteracting || !this.responsavel) {
      return
    }
    await this.responsavel.persistPermitirDataPrevisao(this.responsavel)
    await this.auth()
    success('system.success.persist')
  }

  @Watch('responsavel.permitirBotaoNaoEntregarCarga')
  async persistBotaoNaoEntregarCarga() {
    if (!this.userInteracting || !this.responsavel) {
      return
    }
    await this.responsavel.persistPermitirNaoEntregarCarga(this.responsavel)
    await this.auth()
    success('system.success.persist')
  }

  async persistDisableDataEntregaInferiorDataCriacao() {
    if (!this.userInteracting || !this.responsavel) {
      return
    }
    await this.responsavel.persistDisableDataEntregaInferiorDataCriacao(this.responsavel)
    await this.auth()
    success('system.success.persist')
  }

  async persistDisableDataEntregaInferiorDataEmissao() {
    if (!this.userInteracting || !this.responsavel) {
      return
    }
    await this.responsavel.persistDisableDataEntregaInferiorDataEmissao(this.responsavel)
    await this.auth()
    success('system.success.persist')
  }

    async persistDisableMultiplasFinalizacaoApp() {
        if (!this.userInteracting || !this.responsavel) {
            return
        }
        await this.responsavel.persistDisableMultiplasFinalizacaoApp(this.responsavel)
        await this.auth()
        success('system.success.persist')
    }

  passwordsConfirmed(passwordsMatch: boolean) {
    this.newPasswordConfirmed = passwordsMatch
  }

  async confirmChangePassword() {
    if (this.newPasswordConfirmed && this.responsavel) {
      await this.changePassword(this.responsavel)

      // @ts-ignore
      this.$refs.senha.selected = false
      // @ts-ignore
      this.$refs.senhaVisualizador.selected = false
      // @ts-ignore
      this.$refs.senhaSac.selected = false
      // @ts-ignore
      this.$refs.senhaRastreamento.selected = false

    } else {
      Helper.abort('system.error.passwordsDontMatch')
    }
  }

  get dontAllowSave() {
    return (this.responsavelPermissao.permitirRaioAuditoriaCheckin &&
        !this.responsavelPermissao.raioAuditoriaCheckinMetros ||
        this.responsavelPermissao.permitirRaioAuditoriaEntrega &&
        !this.responsavelPermissao.raioAuditoriaEntregaMetros)
  }

  get disabled() {
    return this.dontAllowSave
  }

  get buttonClass() {
    return this.disabled ? 'disabled-button' : 'primary'
  }

  async downloadXlsx() {
    await $.await.run(() => Helper.downloadXlsx(
        $.t('view.manage.settings.registerDestinatario.reportTitle'),
        new AutoCompleteDestinatario().$endpoint,
        {},
        AutoCompleteDestinatario,
        'AutoCompleteDestinatario',
    ), 'download')
  }

  @Watch('files') // upload
  async filesEvent(files: FileObject[]) {
    if (!files.length) return
    $.await.init('uploadXlsx')

    const file = files[0].file
    const destinatarios: AutoCompleteDestinatario[] = []

    const adaptLine = (obj: any) => ({
      nome: obj.NOME,
      cpfCnpj: obj.CPF_CNPJ,
      telefone: obj.TELEFONE,
      email: obj.EMAIL,
      logradouro: obj.LOGRADOURO,
      numero: obj.NUMERO,
      bairro: obj.BAIRRO,
      cep: obj.CEP,
      cidade: obj.CIDADE,
      uf: (obj.UF || '') as UFInitial,
      complemento: obj.COMPLEMENTO,
    })

    return new Promise((resolve: Function) => {
      const reader = new FileReader()
      reader.onload = async (e) => {
        // @ts-ignore
        const fileData = e.target.result

        let data: any
        data = convertFile(file, fileData)

        if (!data) {
          Helper.abort($.t('system.error.fileInvalidFormat'))
        }

        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const obj = data[key]
            try {
              data[key] = adaptLine(obj)
            } catch {
              Helper.abort($.t('system.error.fileInvalidFormat'))
            }
          }
        }

        data.forEach((item: any) => {
          const destinatario = new AutoCompleteDestinatario()
          Helper.plainToClassFromExist(destinatario, item)
          destinatarios.push(destinatario)
        })

        try {
          await AutoCompleteDestinatario.persist(destinatarios)
        } finally {
          $.await.done('uploadXlsx')
        }

        Helper.success($.t('system.success.persist'))
        resolve()
        this.refreshView()
      }

      if (file) {
        if (file.name.toLowerCase().endsWith('.xls') || file.name.toLowerCase().endsWith('.xlsx')) {
          reader.readAsArrayBuffer(file)
        }
      }
    })
  }
}
